<template>
    <v-footer padless dark class="py-10">
        <v-col class="text-center" cols="12">
            © {{ new Date().getFullYear() }} — Ravenpod, Inc. - All rights reserved.
        </v-col>
    </v-footer>    
</template>

<script>
    export default {
        name: 'Footer',
        data: () => ({
        }),
    }
</script>
